import styled from 'styled-components';

export const Container = styled.div`
  width: 35rem;
  max-width: 90vw;
`;
